var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTornado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.098 1C5.77 3.292 5.647 5.83 6.727 8.615c1.619 4.177 5.322 5.105 5.322 8.803 0 2.465-.266 4.325-.798 5.582 2.733-1.763 4.099-4.02 4.099-6.77 0-4.124-1.976-6.593-1.976-9.562 0-1.98 1.209-3.87 3.626-5.668H7.098z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornado);
export default __webpack_public_path__ + "static/media/tornado.d7007a85c7bab56aca7adbd7152849c6.svg";
export { ForwardRef as ReactComponent };